import React, { useState, useEffect } from "react";
import { fetchKuttConfig, updateKuttConfig } from "../services/kuttService";
import styles from "../components/DomainName/DomainSetter.module.css"; // Reuse existing styles since it looks similar to DomainSetter

const KuttIntegrationPage = () => {
  const [config, setConfig] = useState({
    baseUrl: "",
    apiKey: "",
    active: false,
    preferredDomain: "",
  });
  const [message, setMessage] = useState("");

  useEffect(() => {
    const getConfig = async () => {
      try {
        const data = await fetchKuttConfig();
        setConfig({
          baseUrl: data.baseUrl || "",
          apiKey: data.apiKey || "",
          active: data.active || false,
          preferredDomain: data.preferredDomain || "",
        });
      } catch {
        setMessage("Failed to fetch Kutt config.");
      }
    };
    getConfig();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setConfig({
      ...config,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleUpdate = async () => {
    try {
      await updateKuttConfig(config);
      setMessage("Kutt configuration updated successfully!");
      setTimeout(() => setMessage(""), 3000);
    } catch {
      setMessage("Failed to update Kutt configuration.");
    }
  };

  return (
    <div className={styles.container} style={{ marginTop: "20px" }}>
      <h2 className={styles.heading}>Kutt Integration</h2>

      <div style={{ marginBottom: "15px", display: "flex", flexDirection: "column" }}>
        <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Base URL</label>
        <input
          type="text"
          name="baseUrl"
          value={config.baseUrl}
          onChange={handleChange}
          placeholder="https://kutt.it"
          className={styles.input}
          style={{ width: "100%", padding: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
        />
      </div>

      <div style={{ marginBottom: "15px", display: "flex", flexDirection: "column" }}>
        <label style={{ fontWeight: "bold", marginBottom: "5px" }}>API Key</label>
        <input
          type="password"
          name="apiKey"
          value={config.apiKey}
          onChange={handleChange}
          placeholder="Enter Kutt API Key"
          className={styles.input}
          style={{ width: "100%", padding: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
        />
      </div>

      <div style={{ marginBottom: "15px", display: "flex", flexDirection: "column" }}>
        <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Preferred Shortlink Domain (Optional)</label>
        <input
          type="text"
          name="preferredDomain"
          value={config.preferredDomain}
          onChange={handleChange}
          placeholder="e.g. kutt.v2u.pw or trustworthysale.com"
          className={styles.input}
          style={{ width: "100%", padding: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
        />
        <small style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}>
          Leave empty to use Kutt's default domain. Any domain you enter here MUST be added to your Kutt account first.
        </small>
      </div>

      <div style={{ marginBottom: "15px", display: "flex", alignItems: "center" }}>
        <input
          type="checkbox"
          name="active"
          id="kuttActive"
          checked={config.active}
          onChange={handleChange}
          style={{ marginRight: "10px", transform: "scale(1.2)" }}
        />
        <label htmlFor="kuttActive" style={{ fontWeight: "bold", cursor: "pointer" }}>Enable Kutt Integration</label>
      </div>

      <button onClick={handleUpdate} className={styles.submitButton} style={{ padding: "10px 20px", cursor: "pointer" }}>
        Apply
      </button>

      {message && (
        <p className={styles.statusMessage} style={{ marginTop: "15px", color: message.includes("success") ? "green" : "red" }}>
          {message}
        </p>
      )}
    </div>
  );
};

export default KuttIntegrationPage;
